<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="toolbar-button" (click)="close.emit(false)">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  @switch (authMethod()) {
    @case ('email') {
      <div class="ion-padding-horizontal">
        <header class="my-8">
          <h1>{{ 'AUTH.WELCOME' | translate }}!</h1>

          @if (config()?.passwordResetSent) {
            <p class="subtle">
              {{ 'AUTH.FORGOT_PASSWORD_CHECK_EMAIL' | translate }}
            </p>
          }
        </header>
      </div>

      <form [formGroup]="emailForm" (submit)="loginEmail()">
        <ion-list [inset]="true">
          <ion-item>
            <ion-input
              type="email"
              name="email"
              formControlName="email"
              [label]="'AUTH.EMAIL' | translate"
              labelPlacement="fixed"
              [errorText]="'AUTH.ENTER_VALID_EMAIL' | translate"
              scAutofill
              autocomplete="email"
              email
              required></ion-input>
          </ion-item>
          <ion-item>
            <ion-input
              [type]="showPassword() ? 'text' : 'password'"
              formControlName="password"
              [label]="'AUTH.PASSWORD' | translate"
              labelPlacement="fixed"
              name="password"
              scAutofill
              autocomplete="current-password"
              required></ion-input>
            <ion-button slot="end" fill="clear" size="default" (click)="toggleShowPassword()">
              <ion-icon slot="icon-only" [name]="showPassword() ? 'eye-off' : 'eye'"></ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>

        <div class="ion-padding-horizontal">
          <ion-button expand="block" fill="clear" (click)="switchView.emit({ view: 'forgot-password' })">
            {{ 'AUTH.FORGOT_PASSWORD' | translate }}?
          </ion-button>

          <ion-button expand="block" type="submit" [disabled]="emailForm.invalid">
            {{ 'AUTH.LOGIN' | translate }}
          </ion-button>

          <div class="divider">{{ 'OR' | translate }}</div>

          <ion-button expand="block" fill="outline" (click)="setAuthMethod('phone')">
            {{ 'AUTH.LOGIN_WITH_PHONE' | translate }}
          </ion-button>
        </div>
      </form>
    }
    @case ('phone') {
      <div class="ion-padding-horizontal">
        @if (codeSent()) {
          <header class="my-8">
            <h1>{{ 'AUTH.SMS.ENTER_VERIFICATION_CODE' | translate }}</h1>

            <p class="small">
              {{ 'AUTH.SMS.ENTER_VERIFICATION_CODE_SUBTITLE' | translate }}:
              <strong>{{ obfuscatedPhoneNumber() }}</strong>
            </p>
          </header>

          <ion-input-otp
            #otpInput
            [formControl]="codeControl"
            class="max-w-full"
            length="6"
            shape="soft"></ion-input-otp>

          <div class="small text-center">
            <p>{{ 'AUTH.SMS.DIDNT_GET_CODE' | translate }}</p>

            <ion-button (click)="sendCode()" size="small" [disabled]="disableResetCode()">
              {{ 'AUTH.SMS.RESEND_CODE' | translate }}
              @if (disableResetCode()) {
                ({{ sendCodeCooldown() }})
              }
            </ion-button>
          </div>
        } @else {
          <header class="my-8">
            <h1>{{ 'AUTH.WELCOME' | translate }}!</h1>
          </header>

          <form [formGroup]="phoneNumberForm">
            <ion-grid class="ion-margin-vertical auth-sms-input">
              <ion-row>
                <ion-col size="4">
                  <ion-select
                    class="country-code-select"
                    label="Select country"
                    placeholder="Select country"
                    formControlName="country"
                    [disabled]="countries().length === 0"
                    (ionChange)="countryChanged()">
                    @for (country of countries(); track country.CountryId) {
                      <ion-select-option [value]="country">
                        {{ country.FlagEmoji }} +{{ country.DialingCode }}
                      </ion-select-option>
                    }
                  </ion-select>
                </ion-col>
                <ion-col>
                  <input
                    type="tel"
                    [mask]="phoneNumberForm.controls.country?.value?.PhoneNumberMask || ''"
                    [placeholder]="phoneNumberForm.controls.country?.value?.PhoneNumberMask || ''"
                    [disabled]="countries().length === 0"
                    autocomplete="tel-national"
                    formControlName="phoneNumber"
                    [validation]="true"
                    class="native-input" />
                </ion-col>
              </ion-row>
            </ion-grid>

            <ion-button
              (click)="sendCode()"
              color="primary"
              expand="block"
              [disabled]="phoneNumberForm.invalid || sending()">
              {{ 'AUTH.SMS.SEND_CODE' | translate }}
              <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
            </ion-button>

            @if (canLoginWithEmail()) {
              <div class="divider">{{ 'OR' | translate }}</div>

              <ion-button expand="block" fill="outline" (click)="setAuthMethod('email')">
                {{ 'AUTH.LOGIN_WITH_EMAIL' | translate }}
              </ion-button>
            }
          </form>
        }
      </div>
    }
  }
</ion-content>
